import { render, staticRenderFns } from "./StatsSalesRow.vue?vue&type=template&id=0f0aaefa&"
import script from "./StatsSalesRow.vue?vue&type=script&lang=js&"
export * from "./StatsSalesRow.vue?vue&type=script&lang=js&"
import style0 from "./StatsSalesRow.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports